import { brandByID, brandCreate, brandDestroy, brandList, brandUpdate } from '@/services/agency/brands.service'

export default {
	namespaced: true,
	state: {
		// SERVICE BRAND
		brandList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		brand: {},

		// STATUS SERVICE BRAND
		brandStatus: 'pending',
		brandSaveStatus: 'init',
		brandDeleteStatus: 'init',
	},
	getters: {
		// SERVICE BRAND
		getBrandList(state) {
			return state.brandList
		},
		getBrand(state) {
			return state.brand
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE BRAND
		getBrandDeleteStatus(state) {
			return state.brandDeleteStatus
		},
		getBrandSaveStatus(state) {
			return state.brandSaveStatus
		},
		getBrandStatus(state) {
			return state.brandStatus
		},
	},
	mutations: {
		// SERVICE BRAND
		BRAND_LIST(state, value) {
			state.brandList = value
		},
		SET_BRAND(state, value) {
			state.brand = value
		},

		// STATUS SERVICE BRAND
		BRAND_STATUS(state, value) {
			state.brandStatus = value
		},
		BRAND_SAVE_STATUS(state, value) {
			state.brandSaveStatus = value
		},
		BRAND_DELETE_STATUS(state, value) {
			state.brandDeleteStatus = value
		},
	},
	actions: {
		// Service Brand
		async fetchBrandList({ commit }, params) {
			commit('BRAND_STATUS', 'pending')
			commit('BRAND_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await brandList(params)
				commit('BRAND_STATUS', 'init')
				commit('BRAND_LIST', data)
				return data
			} catch (error) {
				commit('BRAND_STATUS', 'init')
				throw error
			}
		},
		async fetchBrandByID({ commit }, params) {
			commit('BRAND_STATUS', 'pending')
			try {
				const { data } = await brandByID(params)
				commit('BRAND_STATUS', 'init')
				commit('SET_BRAND', data.data)
				return data
			} catch (error) {
				commit('BRAND_STATUS', 'init')

				return error
			}
		},
		async saveNewBrand({ commit }, params) {
			commit('BRAND_SAVE_STATUS', 'pending')
			try {
				const { data } = await brandCreate(params)
				commit('BRAND_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BRAND_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateBrand({ commit }, params) {
			commit('BRAND_SAVE_STATUS', 'pending')
			try {
				const { data } = await brandUpdate(params)
				commit('BRAND_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BRAND_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteBrandByID({ commit }, params) {
			commit('BRAND_DELETE_STATUS', 'pending')
			try {
				const { data } = await brandDestroy(params)
				commit('BRAND_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('BRAND_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
